<!--
     <MapaMeteocat
       title="El meu títol"
       source="https://static-m.meteo.cat/ginys/mapaPrediccio?language=ca&color=2c3e50"
       :image="false"
     />
-->

<template>
  <div class="mm-mapacont">
    <iframe
      :src="source"
      v-if="!image"
    >
      Ops, el teu navegador web fa coses rares... tens habilitats els iframe?
    </iframe>
    
    <v-container v-if="image">
      <v-col>
        <v-row align="center" justify="center">
          <v-card
            
            class="mm-image-cont"
          >
            <v-img
              class="mm-image elevation-2"
              :src="source"
            >
            </v-img>
          </v-card>
        </v-row>
      </v-col>
    </v-container>
    <v-card
      class="mx-auto text-center mm-boxtitle white--text"
    >
      {{ title }}
    </v-card>
  </div>
</template>

<script>
 export default {
   name: 'MapaMeteocat',

   props: [
     'title',
     'source',
     'image',
   ],

   data: () => ({
     //
   }),
 };
</script>

<style>
 .mm-mapacont {
   width: 380px;
 }

 .mm-image-cont {
   margin-bottom: 10px;
 }

 .mm-image {
   height: 505px;
   width: 100%;
 }

 .mm-boxtitle {
   margin-top: -29px;
   width: calc(100% - 20px);
   border-radius: 0px 0px 10px 10px !important;
   box-shadow: 0 3px 3px rgba(25,25,25,.4) !important;
   background-color: #880016 !important;
 }

 iframe {
   border: none;
   width: 100%;
   height: 505px;
   border-radius: 10px;
 }
</style>
